export const apiURL = 'https://cubecobra.com/cube/api'

export const cubeLinkPattern =
  /cubecobra.com\/.*\/(?<cubeID>[a-zA-Z0-9-_]+?)($|\?)/i

export const cubeIDPattern = /^[a-zA-Z0-9-_]+$/
